import AppConfig, { IS_PROD_ENV } from '@/AppConfig';

export const isAnalyticsTurnedOn =
  IS_PROD_ENV || AppConfig.FORCE_ANALYTICS_TURN_ON;

export const FEATURE_FLAGS = {
  CASHLESS_BOT: 'CASHLESS_BOT',
  CASHLESS_CLAIMS_ARTICLES: 'CASHLESS_CLAIMS_ARTICLES',
  NEW_CASHLESS_CREATE: 'NEW_CASHLESS_CREATE',
  NETWORK_HOSPITALS_V3: 'NETWORK_HOSPITALS_V3',
  HEALTH_WALLET_CLAIMS_V2: 'HEALTH_WALLET_CLAIMS_V2',
  TELEHEALTH_WEB: 'TELEHEALTH_WEB',
};

export enum EDevFlag {
  SHOW_LOGS = 'SHOW_LOGS',
}

export enum ETelehealthTriageEvents {
  Telehealth_Triage_QuestionsExplored = 'Telehealth_Triage_QuestionsExplored',
  Telehealth_Triage_LandingPageViewed = 'Telehealth_Triage_LandingPageViewed',
  Telehealth_Triage_CompletionScreenViewed = 'Telehealth_Triage_CompletionScreenViewed',
  Telehealth_Triage_DoctorSelected = 'Telehealth_Triage_DoctorSelected',
  Telehealth_Triage_FeedbackProvided = 'Telehealth_Triage_FeedbackProvided',
  telehealth_findDoctor_feedbackProvided = 'telehealth::findDoctor_feedbackProvided',
  telehealth_findDoctor_entryInitiated = 'telehealth_findDoctor_entryInitiated',
  telehealth_findDoctor_sessionEarlyExit = 'telehealth_findDoctor_sessionEarlyExit',
  /**
   * Underscore separators, per the "Match a therapist events" sheet: these two
   * shipped with `:` and `::` and are being normalised to match the rest.
   *
   * The therapist flow does NOT get its own event names — it reports through
   * these same three, distinguished by the `type` property. That is what makes
   * the two journeys comparable step for step in one funnel.
   *
   * `feedbackProvided` above still carries `::`. It is not in the sheet, so it
   * is left alone rather than renamed on our own initiative.
   */
  telehealth_findDoctor_assessmentComplete = 'telehealth_findDoctor_assessmentComplete',
  telehealth_findDoctor_recommendationAccepted = 'telehealth_findDoctor_recommendationAccepted',
  telehealth_findDoctor_emergencyDetected = 'telehealth_findDoctor_emergencyDetected',
}

/**
 * `type` on emergencyDetected: which triage surfaced the crisis. Deliberately
 * NOT ETriageType — the analytics spec gives this event its own vocabulary,
 * even though it reuses the property name.
 */
export enum EEmergencyType {
  MENTAL_HEALTH = 'mental health',
  PHYSICAL_HEALTH = 'physical health',
}

/**
 * `type` on the triage events: which flow the user is in. Derived from the
 * route — see useTriageType.
 */
export enum ETriageType {
  DOCTOR = 'doctor',
  THERAPIST = 'therapist',
}

/**
 * `source` on the triage events: the surface the user arrived from.
 *
 * Mapped from the host app's entry-surface cookie, whose own values predate
 * this vocabulary — see toEventSource.
 */
export enum EEventSource {
  HEALTH = 'health',
  DOCTOR_LISTING = 'doctor listing',
  MENTAL_HEALTH = 'mental health',
}

export enum ESufaceEntryPoints {
  TELEHEALTH_HOME = 'TELHEALTH HOME',
  TELEHEALTH_SPECIALITY = 'telehealth_speciality',
  TELEHEALTH_MENTAL_HEALTH = 'telehealth_mental_health',
}

export enum EQuestionarreProgress {
  ASSESSMENT_IN_PROGRESS = 'ASSESSMENT_IN_PROGRESS',
  ASSESSMENT_COMPLETED = 'ASSESSMENT_COMPLETED',
  EMERGENCY_DECLARED = 'EMERGENCY_DECLARED',
  DOCTOR_RECOMMENDED = 'DOCTOR_RECOMMENDED',
}

export enum EThemeNames {
  TELEHEALTH_TRIAGE_BOT = 'telehealthTriageBot',
  MATCH_THERAPIST_DEFAULT = 'matchTherapistDefault',
}
